/**
 * Game mode states
 *
 * Defines the possible states the client can be in.
 * Used for controlling camera, input handling, and UI visibility.
 */
export var GameMode;
(function (GameMode) {
    /** Initial state - shows main menu/start screen, camera orbits */
    GameMode["MainMenu"] = "main-menu";
    /** Spectating - observing the game, camera orbits around world */
    GameMode["Spectating"] = "spectating";
    /**
     * Explore - home state: free 3rd-person camera the user can pan/rotate/zoom to
     * explore the world before choosing a spawn point and playing in 1st person.
     */
    GameMode["Explore"] = "explore";
    /** Playing - active gameplay with FPS controls */
    GameMode["Playing"] = "playing";
})(GameMode || (GameMode = {}));
//# sourceMappingURL=gameMode.js.map